// extracted by mini-css-extract-plugin
export default {"root":"SPY_vo"};